<template>
  <div class="box-tab">
    <div id="accordion">  
      <div class="panel box-collapse border-color-skin">
        <div class="box-header with-border box-header-collapse collapsed tab-header" data-toggle="collapse" data-parent="#accordion" href="#detail1_1">
          <h3 class="box-title">
            <i class="fa fa-file-text-o margin-r-5 margin-r-5"></i>{{ labels['HRES33UC3']['0'] }}
          </h3>
        </div>
        <div id="detail1_1" class="panel-collapse collapse in tab-detail">
          <div class="panel-body">

              <div class="detail-block">
                <div class="row">               
                  <div class="col-xs-12 col-ms-6 col-sm-4 col-md-4">
                    <div class="form-group">
                      <label>{{ labels['HRES33UC3']['100'] }}</label>
                      <input type="text" id="coddesc_codinput" name="coddesc_codinput" class="form-control" readonly="readonly" v-model="descCodinput" />
                    </div>
                  </div>

                  <div class="col-xs-12 col-ms-6 col-sm-4 col-md-4">
                    <div class="form-group">
                      <label>{{ labels['HRES33UC3']['10'] }}</label>
                      <input type="text" id="coddesc_codinput" name="coddesc_codinput" class="form-control" readonly="readonly" v-model="descCodempid" />
                    </div>
                  </div>

                  <div class="col-xs-12 col-ms-6 col-sm-4 col-md-4">
                    <div class="form-group">
                      <label>{{ labels['HRES33UC3']['20'] }}</label>
                      <input type="text" id="dtereq" name="dtereq" class="form-control" readonly="readonly" :value="setDateOutput(detail.dtereq)" />
                    </div>
                  </div>              
                </div>
              </div>

              <div class="clearfix detail-block">
                <div class="detail-header">{{ labels['HRES33UC3']['40'] }}</div>

                <div class="row">
                  <div class="col-xs-12 col-ms-4 col-sm-4 col-md-4">
                    <div class="form-group">
                      <label>{{ labels['HRES33UC3']['60'] }}</label>
                      <input type="text" id="title_o" name="title_o" class="form-control" readonly="readonly" v-model="detail.title_o" />
                    </div>
                  </div>

                  <div class="col-xs-12 col-ms-4 col-sm-4 col-md-4">
                    <div class="form-group">
                      <label>{{ labels['HRES33UC3']['70'] }}</label>
                      <input type="text" id="name_ot" name="name_ot" class="form-control" readonly="readonly" v-model="detail.name_ot" />
                    </div>
                  </div>

                  <div class="col-xs-12 col-ms-4 col-sm-4 col-md-4">
                    <div class="form-group">
                      <label>{{ labels['HRES33UC3']['80'] }}</label>
                      <input type="text" id="lastname_ot" name="lastname_ot" class="form-control" readonly="readonly" v-model="detail.lastname_ot" />
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-xs-12 col-ms-4 col-sm-4 col-md-4">
                  </div>
                  <div class="col-xs-12 col-ms-4 col-sm-4 col-md-4">
                    <div class="form-group">
                      <label>{{ labels['HRES33UC3']['110'] }}</label>
                      <input type="text" id="name_oe" name="name_oe" class="form-control" readonly="readonly" v-model="detail.name_oe" />
                    </div>
                  </div>

                  <div class="col-xs-12 col-ms-4 col-sm-4 col-md-4">
                    <div class="form-group">
                      <label>{{ labels['HRES33UC3']['120'] }}</label>
                      <input type="text" id="lastname_oe" name="lastname_oe" class="form-control" readonly="readonly" v-model="detail.lastname_oe" />
                    </div>
                  </div>
                </div>

                <div class="detail-header">{{ labels['HRES33UC3']['50'] }}</div>

                <div class="row">              
                  <div class="col-xs-12 col-ms-4 col-sm-4 col-md-4">
                    <div class="form-group">
                      <label>{{ labels['HRES33UC3']['60'] }}</label>
                      <input type="text" id="title_n" name="title_n" class="form-control" readonly="readonly" v-model="detail.title_n" />
                    </div>
                  </div>

                  <div class="col-xs-12 col-ms-4 col-sm-4 col-md-4">
                    <div class="form-group">
                      <label>{{ labels['HRES33UC3']['70'] }}</label>
                      <input type="text" id="name_nt" name="name_nt" class="form-control" readonly="readonly" v-model="detail.name_nt" />
                    </div>
                  </div>

                  <div class="col-xs-12 col-ms-4 col-sm-4 col-md-4">
                    <div class="form-group">
                      <label>{{ labels['HRES33UC3']['80'] }}</label>
                      <input type="text" id="lastname_nt" name="lastname_nt" class="form-control" readonly="readonly" v-model="detail.lastname_nt" />
                    </div>
                  </div>
                </div>
                <div class="row">              
                  <div class="col-xs-12 col-ms-4 col-sm-4 col-md-4">
                  </div>

                  <div class="col-xs-12 col-ms-4 col-sm-4 col-md-4">
                    <div class="form-group">
                      <label>{{ labels['HRES33UC3']['110'] }}</label>
                      <input type="text" id="name_ne" name="name_ne" class="form-control" readonly="readonly" v-model="detail.name_ne" />
                    </div>
                  </div>

                  <div class="col-xs-12 col-ms-4 col-sm-4 col-md-4">
                    <div class="form-group">
                      <label>{{ labels['HRES33UC3']['120'] }}</label>
                      <input type="text" id="lastname_ne" name="lastname_ne" class="form-control" readonly="readonly" v-model="detail.lastname_ne" />
                    </div>
                  </div>
                </div>

              </div>

              <div class="clearfix">
                <div class="row">
                  <div class="col-xs-12">
                    <div class="form-group">
                      <label>{{ labels['HRES33UC3']['90'] }}</label>
                      <textarea id="desnote" name="desnote" class="form-control" maxlength="600" readonly="readonly">{{ detail.desnote }}
                      </textarea>
                    </div>
                  </div>
                </div>
              </div>

          </div>
        </div>
      </div>
    </div> 

    <div class="box-footer">  
        <button type="button" class="btn bg-dark-gray" @click="toggle('index')" value="Back"><i class="fa fa-chevron-circle-left"></i>{{ buttonLabels['back'] }}</button>
    </div>

  </div>
</template>

<script>
import assetsUtils from 'assets/js/utils'
export default {
  name: 'hres33u-detail1',
  props: [ 'labels', 'detail', 'toggle', 'data', 'nowLang', 'buttonLabels' ],
  computed: {
    descCodinput () {
      return this.detail.codinput + ' - ' + this.detail.desc_codinput
    },
    descCodempid () {
      return this.detail.codempid + ' - ' + this.detail.desc_codempid
    }
  },
  methods: {
    setDateOutput (date) {
      return assetsUtils.getDateOutput(date)
    }
  }
}
</script>



// WEBPACK FOOTER //
// detail1.vue?3d9aa390